export const DELAY_BETWEEN_RETRIES = 2000;

export const DEFAULT_RETRIES = 3;
